import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App.js';

// 🔒 PRODUCTION SECURITY: Disable console in production
// Check if admin has enabled console debugging
const isConsoleEnabled = localStorage.getItem('adminConsoleEnabled') === 'true';

if (process.env.NODE_ENV === 'production' && !isConsoleEnabled) {
  // Override console methods to prevent any leakage
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  // Keep error and warn for critical issues
  // console.error and console.warn remain active
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);